import {
  applyDiscountToCheckout as publicApplyDiscountToCheckout,
  queryLoyaltyCheckoutDiscounts as publicQueryLoyaltyCheckoutDiscounts,
  typedQueryLoyaltyCheckoutDiscounts as publicTypedQueryLoyaltyCheckoutDiscounts,
} from './loyalty-checkoutexchange-v1-loyalty-checkout-discount-checkout-exchange.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  LoyaltyCheckoutDiscountQuery,
  LoyaltyCheckoutDiscountsQueryBuilder,
  typedQueryLoyaltyCheckoutDiscounts as universalTypedQueryLoyaltyCheckoutDiscounts,
} from './loyalty-checkoutexchange-v1-loyalty-checkout-discount-checkout-exchange.universal.js';

function customQueryLoyaltyCheckoutDiscounts(httpClient: HttpClient) {
  const router = /*#__PURE__*/ createQueryOverloadRouter({
    builderQueryFunction: () =>
      publicQueryLoyaltyCheckoutDiscounts(httpClient)(),
    typedQueryFunction: (query: LoyaltyCheckoutDiscountQuery) =>
      publicTypedQueryLoyaltyCheckoutDiscounts(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): LoyaltyCheckoutDiscountsQueryBuilder;
  function overloadedQuery(
    query: LoyaltyCheckoutDiscountQuery
  ): ReturnType<typeof universalTypedQueryLoyaltyCheckoutDiscounts>;
  function overloadedQuery(query?: LoyaltyCheckoutDiscountQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const applyDiscountToCheckout: MaybeContext<
  BuildRESTFunction<typeof publicApplyDiscountToCheckout> &
    typeof publicApplyDiscountToCheckout
> = /*#__PURE__*/ createRESTModule(publicApplyDiscountToCheckout);
export const queryLoyaltyCheckoutDiscounts: MaybeContext<
  BuildRESTFunction<typeof customQueryLoyaltyCheckoutDiscounts> &
    typeof customQueryLoyaltyCheckoutDiscounts
> = /*#__PURE__*/ createRESTModule(customQueryLoyaltyCheckoutDiscounts);

export {
  DiscountStatus,
  DiscountType,
  SortOrder,
  WebhookIdentityType,
} from './loyalty-checkoutexchange-v1-loyalty-checkout-discount-checkout-exchange.universal.js';
export {
  LoyaltyCheckoutDiscount,
  LoyaltyCheckoutDiscountDiscountOneOf,
  DiscountRefundedDueToManualDiscountRemoval,
  DiscountRefundedDueToTimeout,
  DiscountScheduledForRefund,
  ApplyDiscountToCheckoutRequest,
  ApplyDiscountToCheckoutRequestDiscountOneOf,
  Reward,
  LoyaltyCoupon,
  ReferralReward,
  ApplyDiscountToCheckoutResponse,
  QueryLoyaltyCheckoutDiscountsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  AddressLocation,
  CursorPaging,
  QueryLoyaltyCheckoutDiscountsResponse,
  CursorPagingMetadata,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  Empty,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  ApplyDiscountToCheckoutOptions,
  ApplyDiscountToCheckoutOptionsDiscountOneOf,
  LoyaltyCheckoutDiscountsQueryResult,
  LoyaltyCheckoutDiscountsQueryBuilder,
  LoyaltyCheckoutDiscountQuerySpec,
} from './loyalty-checkoutexchange-v1-loyalty-checkout-discount-checkout-exchange.universal.js';
export { utils } from './loyalty-checkoutexchange-v1-loyalty-checkout-discount-checkout-exchange.universal.js';
export {
  DiscountStatusWithLiterals,
  DiscountTypeWithLiterals,
  SortOrderWithLiterals,
  WebhookIdentityTypeWithLiterals,
  CommonQueryWithEntityContext,
  LoyaltyCheckoutDiscountQuery,
} from './loyalty-checkoutexchange-v1-loyalty-checkout-discount-checkout-exchange.universal.js';
